export default __webpack_public_path__ + "static/ASLA_LiniaLounge_3-2c635fb0ad646e25a520026cfc3e4bcf.png";